import api from '@/sui/api/results'
import results from '@/sui/data/results'
import delay from '@/sui/api/delay'
import ice from '@/sui/tools/ice'

import vue from 'vue'

const state = {
  all: {},
  statistics: {
    'SPIADI2019': {},
    'SPIADI2020': {},
    'SPIADI2021': {},
    'SPIADI2022': {}
  }
}

const getters = {
  all: state => {
    return state.all
  },

  getResult: state => (id, d) => {
    const key = `${id}${d}`
    return state.all[key]
  },

  getStatistics: state => r => {
    const key = results.getStatisticsKey(r)
    const stat = state.statistics[r.dset]
    if (stat == null) {
      return null
    }
    return stat[key]
  }
}

const actions = {
  loadResult ({ getters, commit }, request) {
    const key = `${request.s}${request.d}`
    if (getters.getResult(key) == null) {
      return api.loadResult(request).then(
        r => {
          const { v, err } = r.data
          if (err == null && v != null) {
            commit('setResult', { s: key, value: v })
          } else if (err === '[NoResults]') {
            commit('setEmptyResult', key)
          }
          return r
        }
      )
    } else {
      return delay(10)({ data: {} })
    }
  },

  loadStatistics ({ getters, commit }, request) {
    if (getters.getStatistics(request) == null) {
      return api.loadStatistics(request).then(
        r => {
          const { v, err } = r.data
          if (err == null && v != null) {
            commit('setStatistics', { request: request, value: v })
          }
          return r
        }
      )
    } else {
      return delay(10)({ data: {} })
    }
  }
}

function mutations (forbidden) {
  return {
    setEmptyResult (state, id) {
      vue.set(state.all, id, { empty: true })
    },

    setResult (state, data) {
      const result = ice.freeze(
        results.flattenIncidences(
          forbidden, data.value.i, data.value.t
        )
      )
      vue.set(state.all, data.s, result)
    },

    setStatistics (state, data) {
      const result = results.flattenStatistics(data.value, forbidden)
      const ds = data.request.dset
      for (let k in result) {
        if (state.statistics[ds] == null) {
          vue.set(state.statistics, ds, {})
        }

        vue.set(
          state.statistics[ds], k, ice.freeze(result[k])
        )
      }
    }
  }
}

export default function (forbidden) {
  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations: mutations(forbidden)
  }
}
